/**
 * tab menu
 */

export function tab_menu() {
  document.addEventListener('DOMContentLoaded', function () {
    var elements = document.querySelectorAll('.search-btn-area .btn.-arrow-a');

    elements.forEach(function (element) {
      element.addEventListener('click', function () {
        // クリックされたボタン以外のすべてのボタンから 'is-active' クラスを削除
        elements.forEach(function (otherElement) {
          if (otherElement !== element) {
            otherElement.classList.remove('is-active');
          }
        });

        // クリックされたボタンに 'is-active' クラスをトグル
        this.classList.toggle('is-active');
      });
    });
  });
}
